import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
  CardSubtitle,
  CardHeader,
  Button,
} from "reactstrap"

import { Link } from "react-router-dom"

import "./DecisionInfo.css"
import PlasticsApplication from "services/PlasticsApplication.service"

const user = JSON.parse(localStorage.getItem("authUser"))
const plasticsApp = new PlasticsApplication(user)

const DecisionInfo = props => {
  const [badge, setbadge] = useState("alert alert-info")
  const [statusMessage, setstatusMessage] = useState("")

  useEffect(() => {
    if (
      props.data.isManuallyProcessed != undefined &&
      props.data.isManuallyProcessed == true &&
      props.data.final_certificate_uploaded == null &&
      props.data.statusId === 6
    ) {
      setstatusMessage("UNDER REVIEW")
      setbadge("alert alert-info")
    } else if (props.data.statusId === 6) {
      setstatusMessage("APPROVED")
      setbadge("alert alert-success")
    } else if (props.data.statusId === 7) {
      setstatusMessage("RETURNED")
      setbadge("alert alert-warning")
    } else if (props.data.statusId === 9) {
      setstatusMessage("REJECTED")
      setbadge("alert alert-danger")
    } else if (props.data.statusId === 2) {
      setstatusMessage("SUBMITTED")
      setbadge("alert alert-info")
    } else {
      setstatusMessage("UNDER REVIEW")
      setbadge("alert alert-info")
    }
  }, [props.data.statusId])

  const download = (path, name) => {
    plasticsApp
      .downloadAttachment(path)
      .then(response => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", name)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
      })
      .catch(err => {
        console.log(err)
      })
  }
  return (
    <Card>
      <CardHeader>Decision</CardHeader>
      <CardBody>
        <Row>
          <Col md="4">
            <Row>
              <b>Application Type</b>{" "}
            </Row>{" "}
            <Row>{props.data.service}</Row>
          </Col>
          <Col md="4">
            <span className={badge}>Status: {statusMessage}</span>
          </Col>
          <Col md="4">
            <Row>Comments</Row> <Row>{props.data.comments}</Row>
          </Col>
        </Row>
        {props.data.statusId === 6 ? (
          <Row className="mt-4 d-flex justify-content-center">
            <Col md="4"></Col>
            <Col md="4">
              {props.data.isManuallyProcessed &&
              props.data.final_certificate_uploaded ? (
                <a
                  href="#"
                  onClick={e =>
                    download(
                      props.data.manual_certificate.path,
                      props.data.manual_certificate.file_name
                    )
                  }
                >
                  Download Certificate{" "}
                  <i
                    className="fas fa-cloud-download-alt"
                    title="Download"
                    style={{ color: "green" }}
                  ></i>
                </a>
              ) : (
                ""
              )}

              {!props.data.isManuallyProcessed ? (
                <a
                  target="_blank"
                  href={props.data.certUrl}
                  className="btn btn-success"
                >
                  {" "}
                  Download Certificate{" "}
                </a>
              ) : null}
            </Col>
            <Col md="4"></Col>
          </Row>
        ) : (
          ""
        )}
      </CardBody>
    </Card>
  )
}

export default DecisionInfo
